import axios from 'axios';
const request = axios.create({
  headers: {
    'X-Client-Version': process.env.VUE_APP_AROBA_API_X_Client_Version,
  },
});

request.interceptors.request.use(
  function (config) {
    if (!navigator.onLine) {
      // if offline reject request
      return Promise.reject(new Error('No internet connection'));
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

request.interceptors.response.use(
  (response) => {
    return response;
  },
  (err) => {
    return Promise.reject(err);
  }
);

export default request;
